import React, { Component } from "react";
import API from "../../apiService.js";
import moment from "moment";
import ALERT from "../component/Alert";
import Auth from "../../auth";
import MedicalCertificateList from "../medicalCertificate/MedicalCertificateList";
import MedicalCertificatePrint from "../medicalCertificate/MedicalCertificatePrint";
import ReactToPrint from "react-to-print";
import PrintButton from "../medical/PrintButton";

export default class FormSehat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refExplanation: [],
      data: {
        visit_id: this.props.detilPx.id,
        number: "",
        result: "sehat",
        mc_see: true,
        mc_hear: true,
        explanation_id: 1,
        other_explanation: "",
        explanation: "",
      },
      profiles: "",
      nomor_surat: "",
      MedicalCertificate: [],
    };
  }
  componentDidMount() {
    this.getExplanation();
    this.getProfile();
    this.getMedicalLetterNo();
    this.getMedicalCertificate();
  }
  getMedicalLetterNo = async () => {
    let date = moment(this.props.detilPx.created_at).format("YYYY-MM-DD");
    const res = await API.get(
      "registration/medical_certificates/select/" + date
    );
    if (res.code === 200) {
      this.setState((prevState) => ({
        data: {
          // object that we want to update
          ...prevState.data, // keep all other key-value pairs
          number: res.data, // update the value of specific key
        },
      }));
    }
  };
  getMedicalCertificate = async () => {
    const res = await API.get(
      "registration/medical_certificates/read/" + this.props.detilPx.id
    );
    if (res.code === 200) {
      this.setState({
        MedicalCertificate: res.data,
      });
    }
  };

  getExplanation = async () => {
    const res = await API.get("management/medical_certificates/read");
    if (res.code === 200) {
      this.setState({
        refExplanation: res.data,
      });
    }
  };

  getProfile = async () => {
    let userdata = JSON.parse(localStorage.getItem("userData"));
    let puskesmas_id = userdata.puskesmas_id;
    const res = await API.get("/management/profiles/read?code=" + puskesmas_id);
    if (res.code === 200) {
      this.setState({
        profiles: res.data,
      });
      this.setState({
        nomor_surat:
          "/" +
          res.data.nama_singkat +
          "/" +
          this.convertToRom(moment().format("M")) +
          "/" +
          moment().format("YYYY"),
      });
    }
  };
  handleChangeText = (event) => {
    let value = event.target.value;
    let object = event.target.name;
    let data;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [object]: value, // update the value of specific key
      },
    }));
  };
  handleChangeTextExplanation = (event) => {
    let value = event.target.value;
    let object = event.target.name;
    let id = event.target.id;
    let data;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [object]: value, // update the value of specific key
        explanation: id,
      },
    }));
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  PostData = async () => {
    var param = {
      visit_id: this.state.data.visit_id,
      number: this.state.data.number + this.state.nomor_surat,
      result: this.state.data.result,
      mc_see: this.state.data.mc_see,
      mc_hear: this.state.data.mc_hear,
      explanation_id: this.state.data.explanation_id,
      other_explanation: this.state.data.other_explanation,
      explanation: this.state.data.explanation,
    };

    let res = await API.post(`registration/medical_certificates/create`, param);

    if (res.code === 200) {
      if (res.code === 200) {
        ALERT("success", "Berhasil Menyimpan Data ");

        this.getMedicalCertificate();
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };
  convertToRom(num) {
    var remainingValue = num;
    var newRomanNumeral = "";

    var romanNumerals = [
      {
        numeral: "M",
        value: 1000,
      },
      {
        numeral: "CM",
        value: 900,
      },
      {
        numeral: "D",
        value: 500,
      },
      {
        numeral: "CD",
        value: 400,
      },
      {
        numeral: "C",
        value: 100,
      },
      {
        numeral: "XC",
        value: 90,
      },
      {
        numeral: "L",
        value: 50,
      },
      {
        numeral: "XL",
        value: 40,
      },
      {
        numeral: "X",
        value: 10,
      },
      {
        numeral: "IX",
        value: 9,
      },
      {
        numeral: "V",
        value: 5,
      },
      {
        numeral: "IV",
        value: 4,
      },
      {
        numeral: "I",
        value: 1,
      },
    ];

    for (var i = 0; i < 13; i++) {
      var j = Math.floor(remainingValue / romanNumerals[i].value); // j represents the number of times each character is needed
      while (remainingValue >= romanNumerals[i].value) {
        newRomanNumeral += romanNumerals[i].numeral.repeat(j); // Add 'x' Numerals to the string
        remainingValue -= romanNumerals[i].value * j; // decrement the remaining value
      }
    }

    return newRomanNumeral;
  }

  render() {
    console.log(this.state);

    let explanation = this.state.refExplanation.map((ex, ky) => {
      return (
        <div key={ky} className='custom-control custom-radio'>
          <input
            name='explanation_id'
            className='custom-control-input'
            id={ex.name}
            value={ex.id}
            type='radio'
            onChange={this.handleChangeTextExplanation}
          />
          <label className='custom-control-label' htmlFor={ex.name}>
            {ex.name}
          </label>
        </div>
      );
    });
    let nomor_surat = this.state.nomor_surat;
    // console.log(this.props);
    return (
      <div>
        <div className='card'>
          <div className='card-header'>
            <div className='row align-items-center'>
              <div className='col-8'>
                <h4 className='h3 mb-0'>Form Surat Keterangan Sehat</h4>
              </div>
              {this.props.detilPx.paramedic_id &&
              this.state.MedicalCertificate[0] ? (
                <div className='col-4 text-right'>
                  <PrintButton
                    url={`/registration/medical_certificates/print/${this.state.MedicalCertificate[0].id}`}
                    buttonText='Cetak'
                    color='neutral'
                  />
                  {/* <button
                      type='button'
                      className='btn btn-sm btn-neutral'
                      data-toggle='collapse'
                      data-target='#collapsePreview'
                      aria-expanded='false'
                      aria-controls='collapsePreview'>
                      <span className="btn-inner--icon"><i className="fas fa-eye"></i></span>
                      <span className="btn-inner--text"> Pratinjau</span>
                    </button>
                    <ReactToPrint
                      trigger={() => (
                        <a href="#">
                          <button className="btn btn-sm btn-neutral" type="button" >
                            <span className="btn-inner--icon"><i className="fa fa-print"></i></span>
                            <span className="btn-inner--text"> Cetak</span>
                          </button>
                        </a>
                      )}
                      content={() => this.componentRef}
                    /> */}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className='collapse' id='collapsePreview'>
              <br></br>
              <div className='list-group-item' style={{ display: "block" }}>
                <MedicalCertificatePrint
                  ref={(el) => (this.componentRef = el)}
                  patient={this.props.detilPx}
                  medCertif={this.state.MedicalCertificate[0]}
                />
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Nomor
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <input
                    className='form-control col-md-3'
                    type='text'
                    placeholder='nomor'
                    name='number'
                    value={this.state.data.number}
                    onChange={this.handleChangeText}
                  />
                  <input
                    className='form-control col-md-9'
                    type='text'
                    name='nomor_singkatan'
                    value={nomor_surat}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Hasil
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='result'
                      className='custom-control-input'
                      id='hasilSehat'
                      type='radio'
                      checked={this.state.data.result === "sehat"}
                      value='sehat'
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='hasilSehat'>
                      Sehat
                    </label>
                  </div>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='result'
                      className='custom-control-input'
                      id='hasilSakit'
                      value='tidak sehat'
                      type='radio'
                      checked={this.state.data.result === "tidak sehat"}
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='hasilSakit'>
                      Tidak Sehat
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Penglihatan
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='mc_see'
                      className='custom-control-input'
                      id='penglihatanSehat'
                      type='radio'
                      checked={
                        this.state.data.mc_see === true ||
                        this.state.data.mc_see === "true"
                      }
                      value={true}
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='penglihatanSehat'>
                      Tidak Buta Warna
                    </label>
                  </div>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='mc_see'
                      className='custom-control-input'
                      id='penglihatanSakit'
                      value={false}
                      type='radio'
                      checked={
                        this.state.data.mc_see === false ||
                        this.state.data.mc_see === "false"
                      }
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='penglihatanSakit'>
                      Buta Warna
                    </label>
                  </div>
                </div>
              </div>
            </div> */}
            <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Pendengaran
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='mc_hear'
                      className='custom-control-input'
                      id='pendengaranSehat'
                      type='radio'
                      checked={
                        this.state.data.mc_hear === true ||
                        this.state.data.mc_hear === "true"
                      }
                      value={true}
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='pendengaranSehat'>
                      Sehat
                    </label>
                  </div>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                      name='mc_hear'
                      className='custom-control-input'
                      id='pendengaranSakit'
                      value={false}
                      checked={
                        this.state.data.mc_hear === false ||
                        this.state.data.mc_hear === "false"
                      }
                      type='radio'
                      onChange={this.handleChangeText}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='pendengaranSakit'>
                      Tidak Sehat
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Surat Keterangan sehat ini digunakan untuk :
              </label>
              <div className='col-md-7'>
                {explanation}

                <input
                  type='text'
                  placeholder='lainnya'
                  className='form-control'
                  name='other_explanation'
                  onChange={this.handleChangeText}
                />
              </div>
            </div>
            <button
              type='submit'
              className='btn btn-primary'
              onClick={this.PostData}>
              Simpan
            </button>
            <button className='btn btn-danger' onClick={this.onReload}>
              Tutup
            </button>
            <div className='col-12 mt-4'>
              <MedicalCertificateList
                patient={this.props.detilPx}
                MedicalCertificate={this.state.MedicalCertificate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
